import Vue from 'vue'
import VueRouter from 'vue-router'
import DashboardLayout from '@/layout/DashboardLayout'
import AuthLayout from '@/layout/AuthLayout'
import firebase from '@/config/firebase.js';

import store from './store/index';

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: 'dashboard',
    component: DashboardLayout,
    children: [
      {
        path: '/dashboard',
        name: 'dashboard',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "demo" */ './views/dashboard/Dashboard.vue'),
        meta: {
          requiresAuth: true
        }
      }, 
      {
        path: '/organizations',
        component: () => import(/* webpackChunkName: "demo" */ './views/organizations/Organizations.vue'),
        name: 'organizations',
        meta: {
          requiresAuth: true
        }
      }, 
      {
        path: '/potentialees',
        component: () => import(/* webpackChunkName: "demo" */ './views/potentialees/Potentialees.vue'),
        name: 'potentialees',
        meta: {
          requiresAuth: true
        }
      }, 
      {
        path: '/potentialeelists',
        component: () => import(/* webpackChunkName: "demo" */ './views/potentialeelists/PotentialeeLists.vue'),
        name: 'potentialeelists',
        meta: {
          requiresAuth: true
        }
      },
      {
        path: '/jobboard',
        component: () => import(/* webpackChunkName: "demo" */ './views/jobboard/JobBoard.vue'),
        name: 'jobboard',
        meta: {
          requiresAuth: true
        }
      },
      {
        path: '/resources',
        component: () => import(/* webpackChunkName: "demo" */ './views/resources/Resources.vue'),
        name: 'resources',
        meta: {
          requiresAuth: true
        }
      },
      {
        path: '/users',
        component: () => import(/* webpackChunkName: "demo" */ './views/users/Users.vue'),
        name: 'users',
        meta: {
          requiresAuth: true
        }
      },
      {
        path: '/help',
        name: 'help',
        component: () => import(/* webpackChunkName: "demo" */ './views/help/Help.vue'),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: '/profile',
        name: 'profile',
        component: () => import(/* webpackChunkName: "demo" */ './views/UserProfile.vue'),
        meta: {
          requiresAuth: true
        }
      }
    ]
  },
  {
    path: '/',
    redirect: 'login',
    component: AuthLayout,
    children: [
      {
        path: '/login',
        name: 'login',
        component: () => import(/* webpackChunkName: "demo" */ './views/Login.vue'),
        meta: {
          requiresGuest: true
        }
      }
    ]
  }
]




const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  linkExactActiveClass: 'active',
  routes
});


//router Guards
router.beforeEach((to, from, next) => {
  const currentUser = firebase.auth().currentUser;
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);

  store.commit('setCurrentUser', currentUser);

  if (requiresAuth && !currentUser) next('/login');
  else if (!requiresAuth && currentUser) next('/dashboard');
  else next();
});


export default router